import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-bills-transaction',
  templateUrl: './bills-transaction.component.html',
  styleUrls: ['./bills-transaction.component.scss']
})
export class BillsTransactionComponent implements OnInit {

  static that: BillsTransactionComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;

  @Input() shipmentModetypearray: any = [];
  @Input() parentTypearray: any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
  ) {
    BillsTransactionComponent.that = this;
  }

  ngOnInit() {
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);


    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');

    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Id']) {
      this.Id = changes['Id'].currentValue;
      if (changes['shipmentModetypearray']) {
        this.shipmentModetypearray = changes['shipmentModetypearray'].currentValue;
      }
      if (changes['parentTypearray']) {
        this.parentTypearray = changes['parentTypearray'].currentValue;
      }
    }

  }

  async initalizeForm() {
    this.tableDetails = {
      emptyDataMSg: 'No Data Found',
      data: [],
      columnDetails: [
        { columnName: 'Bill No', dataFieldName: 'BillNo', dataFieldName3: 'CreatedDate', divType: 'UserDetails' },
        { columnName: 'Voucher Type', dataFieldName: 'VoucherType' },
        { columnName: 'THC', dataFieldName: 'THCNo' },
        { columnName: 'Reference No', dataFieldName: 'ReferenceNo' },
        { columnName: 'Vendor', dataFieldName: 'VendorName', divType: '' },
        { columnName: 'Credit Days', dataFieldName: 'CreditDays', color: 'CreditDaysColor', divType: 'salesInvoiceNew' },
        { columnName: 'Due Date', dataFieldName: 'DueDate', divType: '' },
        { columnName: 'Amount', dataFieldName: 'Amount', divType: '' },
        { columnName: 'Due Amount', dataFieldName: 'BalanceDue', divType: '' },
        { columnName: 'Container No', dataFieldName: 'ContainerNo', divType: '' },
        { columnName: 'Status', dataFieldName: 'billStatus', divType: 'status' },
      ],
      isColumnNameShow: true
    }
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {

    Helpers.setLoading(true);

    if (CompanyId !== undefined && CompanyId !== null) {
      this.CompanyId = CompanyId;
    }

    this.payload.Length = perPage;

    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;

    this.payload.BillSearch = searchValue || null;
    this.payload.BillId = null;
    this.payload.VendorId = null;

    if (this.parentTypearray.includes('transporter') || this.parentTypearray.includes('transporter') || this.shipmentModetypearray.includes('road freight')) {
      this.payload.VendorId = Id ? Id : this.Id;
    }
    else {
      this.payload.VendorId = null;
    }


    this.payload.tripId = null;
    this.payload.containerNo = null;
    this.payload.Financialyear = null;
    this.payload.FromDate = this.data.FromDate || null;
    this.payload.ToDate = this.data.ToDate || null;
    this.payload.Status = null;

    if (this.referenceType == 'Driver') {
      this.payload.DriverId = Id ? Id : this.Id;
    }
    else {
      this.payload.DriverId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("Bills", "GetPurchaseBills", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].Count;
        // this.isListApiCalled = true;
        response.forEach((item) => {
          let btn = '';
          let color = '';

          if (item.BalanceDue !== 0) {
            if (item.DateDifference >= 0) {
              const due = 'Due in';
              const days = 'Days';
              btn = `${due} ${item.DateDifference} ${days}`;
              color = '#3367FB';
            } else {
              const overdue = 'Over Due By';
              const days = 'Days';
              btn = `${overdue} ${Math.abs(item.DateDifference)} ${days}`;
              color = '#F13637';
            }
          } else {
            btn = `Paid`;
            color = '#4BB543';
          }
          item.CreditDays = btn;
          item.CreditDaysColor = color;
        });
      }
      this.assignTableFields(pageNo, perPage, response);
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }

  onPageChange(pageNo: number) {
    this.GetTransactionList('', pageNo - 1, {}, this.noOfPages, this.Id, this.CompanyId);
  }

  onPageNumberChange(noOfPages: any) {
    this.noOfPages = noOfPages;
    this.GetTransactionList("", 0, {}, noOfPages, this.Id, this.CompanyId);
  }

  GetTransactionListDownload(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id
  ) {
    Helpers.setLoading(true);

    this.payload.Start = pageNo * perPage;
    this.payload.Length = perPage;
    this.payload.CompanyId = this.CompanyId;
    this.payload.BillSearch = searchValue || null;
    this.payload.BillId = null;
    this.payload.VendorId = null;
    this.payload.tripId = null;
    this.payload.containerNo = null;
    this.payload.Financialyear = null;
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = 'All';


    this.payload.Length = perPage;
    this.payload.CompanyId = this.CompanyId;
    this.payload.BillSearch = searchValue || null;
    this.payload.BillId = null;
    this.payload.VendorId = null;

    if (this.parentTypearray.includes('transporter') || this.parentTypearray.includes('transporter') || this.shipmentModetypearray.includes('road freight')) {
      this.payload.VendorId = Id ? Id : this.Id;
    }
    else {
      this.payload.VendorId = null;
    }


    this.payload.tripId = null;
    this.payload.containerNo = null;
    this.payload.Financialyear = null;
    this.payload.FromDate = this.data.FromDate || null;
    this.payload.ToDate = this.data.ToDate || null;
    this.payload.Status = null;

    if (this.referenceType == 'Driver') {
      this.payload.DriverId = Id ? Id : this.Id;
    }
    else {
      this.payload.DriverId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("Bills", "GetPurchaseBillsDownload", this.payload).subscribe((response) => {
      this.DownloadFile(response);
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while downloading", error);
      }
    );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

}
